export default __webpack_public_path__ + "static/media/Logo.69e691cd.png";